import moment from 'moment'
import _isDate from 'lodash/isDate'

export default {
  isISO8601Format(date) {
    return moment(date, moment.ISO_8601).isValid()
  },

  /**
   * @desc Takes a date and creates a new Date shifted by the original date's offset
   * @param {Date|Moment}
   * @return Date
   */
  toDateWithDateOffset(date) {
    if (!date) throw new Error('dateUtilsService - createDateWithDateOffset() - date is required')
    if (!_isDate(date))
      throw new Error('dateUtilsService - createDateWithDateOffset() - date must be a Date object')

    return new Date(date.getTime() + 60000 * date.getTimezoneOffset())
  },

  /**
   * @desc Takes a date and creates a new UTC moment from it at 6AM, ignoring the time on the date passed in
   * @param {Date|Moment}
   * @return Moment
   */
  toUTCMomentWithoutTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date is required')
    if (!_isDate(date) && !moment.isMoment(date))
      throw new Error(
        'dateUtilsService - toUTCMomentWithoutTime() - date must be a Date object or a Moment object'
      )

    return moment.isMoment(date)
      ? moment.utc([date.get('year'), date.get('month'), date.get('date'), 6])
      : moment.utc([date.getFullYear(), date.getMonth(), date.getDate(), 6])
  },

  /**
   * @desc Takes a date and creates a new UTC moment from it at 6AM, ignoring the time on the date passed in
   * @param {Date|Moment}
   * @return Moment
   */
  toUTCDateWithoutTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date is required')
    if (!_isDate(date) && !moment.isMoment(date))
      throw new Error(
        'dateUtilsService - toUTCMomentWithoutTime() - date must be a Date object or a Moment object'
      )

    return moment.isMoment(date)
      ? new Date(date.get('year'), date.get('month'), date.get('date'), 6)
      : new Date(date.getFullYear(), date.getMonth(), date.getDate(), 6)
  },

  /**
   * @desc Takes a date and creates a new UTC unix timestamp from it at 6AM, ignoring the time on the date passed in
   * @param {Date|Moment}
   * @return Number - date in milliseconds
   */
  toUTCTimestampWithoutTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCTimestampWithoutTime() - date is required')
    if (!_isDate(date) && !moment.isMoment(date))
      throw new Error(
        'dateUtilsService - toUTCTimestampWithoutTime() - date must be a Date object or a Moment object'
      )

    return moment.isMoment(date)
      ? Date.UTC(date.get('year'), date.get('month'), date.get('date'), 6)
      : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 6)
  },

  /**
   * @desc Takes a date and creates a new UTC unix timestamp from it, including time from the date passed in
   * @param {Date|Moment}
   * @return Number - date in milliseconds
   */
  toUTCTimestampWithTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCTimestampWithTime() - date is required')
    if (!_isDate(date) && !moment.isMoment(date))
      throw new Error(
        'dateUtilsService - toUTCTimestampWithTime() - date must be a Date object or a Moment object'
      )

    return moment.isMoment(date)
      ? Date.UTC(
          date.get('year'),
          date.get('month'),
          date.get('date'),
          date.get('hour'),
          date.get('minute'),
          date.get('second'),
          date.get('millisecond')
        )
      : Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
          date.getMilliseconds()
        )
  },
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js